import { CoveoProductModel } from "@NA/Types/CoveoModel";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import translate from "@insite/client-framework/Translate";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { css } from "styled-components";

interface OwnProps {
    product: CoveoProductModel;
    isAuthenticated?: boolean;
    extendedStyles?: TagsStyles;
}

export interface TagsStyles {
    tagsContainer?: InjectableCss;
    tags?: TypographyProps;
}

const tagsStyles: TagsStyles = {
    tags: {
        css: css`
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            padding: 4px 15px !important;
            background-color: #2380a3;
            flex-grow: 0;
            font-size: 12px;
            font-weight: 800;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: center;
            color: #fff;
            border-radius: 0;
            border-top-left-radius: 5px;
            border-bottom-right-radius: 5px;
            min-height: 24px;
            width: auto;
            line-height: 1;
            white-space: normal;
            height: auto;
        `,
    },
    tagsContainer: {
        css: css`
            position: absolute;
            top: 0;
            left: 0;
        `,
    },
};

function ADIProductSaleInfo({ product, isAuthenticated, extendedStyles }: OwnProps) {
    if (!product) return null;
    const [styles] = React.useState(() => mergeToNew(tagsStyles, extendedStyles));
    const checkIfNotSales =
        product.saleType !== "AC" &&
        product.saleType !== "EV" &&
        product.saleType !== "SM" &&
        product.saleType !== "ED" &&
        product.saleType !== "CD" &&
        product.saleType !== "DD" &&
        product.saleType !== "WS" &&
        product.saleType !== "OO" &&
        product.saleType !== "SD" &&
        product.saleType !== "LT" &&
        product.saleType !== "FS" &&
        product.saleType !== "BF";

    const isClearance = checkIfNotSales && product?.classificatioN_CODE?.toLowerCase() === "x";
    const isHotDeal = isAuthenticated && checkIfNotSales && product.saleType === "HD";

    const isSale =
        checkIfNotSales && product.classificatioN_CODE !== "X" && product.onSaleNow === "1";

    const isADIChoice = product.saleType === "AC";

    const isNew =
        checkIfNotSales &&
        product?.classificatioN_CODE?.toLowerCase() !== "X" &&
        product.onSaleNow !== "1" &&
        product.isNewProduct === "NP";

    const getSaleTypeText = (saleType: string): string => {
        const saleTypeText: Record<string, string> = {
            BF: "Black Friday",
            FS: "Flash Sale",
            LT: "Limited Time",
            SD: "Special Deal",
            WS: "Online Only",
            OO: "Online Only",
            DD: "Daily Deal",
            CD: "Cyber Deal",
            ED: "Expo Deal",
            EV: "Everyday Value",
            SM: "Save More",
        };
        return (saleTypeText[saleType]) || "";
    };

    return (
        <StyledWrapper {...styles.tagsContainer}>
            {isClearance ? (
                <Typography {...styles.tags}>{translate("Clearance")}</Typography>
            ) : isHotDeal ? (
                <Typography {...styles.tags}>{translate("Hot Deal")}</Typography>
            ) : isSale ? (
                <Typography {...styles.tags}>{translate("Sale")}</Typography>
            ) : isADIChoice ? (
                <Typography {...styles.tags}>{translate("ADI Choice")}</Typography>
            ) : isNew ? (
                <Typography {...styles.tags}>{translate("New")}</Typography>
            ) : (
                <>
                    {["BF", "FS", "LT", "SD", "WS", "OO", "DD", "CD", "ED", "EV", "SM", "AC"].map(
                        saleType =>
                            product.saleType === saleType && (
                                <Typography {...styles.tags}>{translate(getSaleTypeText(saleType))}</Typography>
                            ),
                    )}
                </>
            )}
        </StyledWrapper>
    );
}

export default ADIProductSaleInfo;
